import parseArcaResponse from '../parseArcaResponse';

export interface OneTimeContributionLimits {
	/** Tope anual de aportación de la persona (1.500 / 5.750 / 10.000 €). */
	annualCap: number;
	/** Aportado y confirmado en lo que va de año. */
	contributedThisYear: number;
	/** Margen disponible = importe MÁXIMO de esta aportación puntual. */
	remaining: number;
	/** Importe mínimo por operación. */
	minAmount: number;
	/** Aportaciones mensuales que quedan por ejecutarse este año. */
	remainingScheduledRuns: number;
	/**
	 * ¿Puede aportar HOY? Es el guard de "máximo una al día" del backend,
	 * adelantado para que el modal no prometa una aportación que se va a rechazar.
	 * `remaining` viene igual cuando es `false`: mañana sí podrá usarlo.
	 *
	 * **Opcional a propósito**: lo devuelve comparsa desde la PR #702, así que
	 * llega `undefined` con un backend anterior o si se hace rollback. Marcarlo
	 * obligatorio haría que TypeScript avalase un `if (!limits.canContributeToday)`
	 * que en ese hueco bloquearía a TODO el mundo sin que nadie se enterase.
	 */
	canContributeToday?: boolean;
}

export interface GetOneTimeContributionLimitsResponse {
	success: boolean;
	data?: OneTimeContributionLimits;
}

/**
 * Margen disponible en el plan para una aportación puntual.
 *
 * Lo pide el modal al abrirse para pintar el mínimo y el máximo REALES: el
 * backend calcula ambos con el mismo código con el que después valida, así que
 * lo que se le enseña al usuario es exactamente lo que se le va a aceptar.
 *
 * `planCatalogId` tiene que ser el MISMO que viajará en la aportación: cada plan
 * tiene su tope y su propio consumo, así que calcular el margen sobre otro
 * enseñaría un máximo que la propia aportación rechaza.
 */
const getOneTimeContributionLimits = async (
	token: string,
	planCatalogId?: string
): Promise<GetOneTimeContributionLimitsResponse> => {
	const query = planCatalogId ? `?planCatalogId=${encodeURIComponent(planCatalogId)}` : '';

	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/users/one-time-contribution/limits${query}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	return parseArcaResponse<GetOneTimeContributionLimitsResponse>(response);
};

export default getOneTimeContributionLimits;
